import { NeedsActionDto, NeedsActivityDto } from '@act/shared/data-transfer-objects';

interface NeedIssueLike {
  activityIds: number[];
}

/**
 * Filters and sorts activities available for a need action form.
 *
 * @param activities - Full activity catalog from metadata.
 * @param issue - Need issue with allowed activity ids.
 * @param action - Optional existing action when editing.
 * @returns Activities the user may select for this need.
 */
export function selectActivityOptionsForNeedAction(
  activities: NeedsActivityDto[],
  issue: NeedIssueLike,
  action?: NeedsActionDto
): NeedsActivityDto[] {
  return activities
    .filter(a => {
      let latestAction: NeedsActionDto | undefined;
      if (action) {
        const allActions = [action, ...(action.subsequentActions || [])];
        allActions.sort((x, y) => y.createdAt - x.createdAt);
        latestAction = allActions[0];
      }
      return (
        issue.activityIds.includes(a.id) ||
        latestAction?.activityId === a.id
      );
    })
    .sort((a, b) => {
      if (b.label < a.label) return 1;
      if (b.label > a.label) return -1;
      return 0;
    });
}
